<template>
    <div>
        <div v-if="hidden_title === false" class="container bg-light py-4 text-bat">
            <div class="conoce-avance-vendedores">
        <div class="row">
            <!-- Columna izquierda -->
            <div class="col-12 col-md-6">
                <h5 class="text-title-bat">Conoce tu avance</h5>
                <p>Aquí podrás ver el avance de tus variables del mes seleccionado.</p>
                <div class="col-12 col-md-5 col-lg-4 bg-white rounded-4 shadow p-2">
                    <div class="row">
                        <div class="col-4 d-flex justify-content-center align-items-center pe-0 progress-working-days">
                            <el-progress type="circle"
                                         class="fw-bold"
                                         :percentage="Math.round(Number(this.advanceWorkingDays) * 10000) / 100"
                                         :width="60"
                                         :stroke-width="5"
                                         :color="customColorWorkDays">
                            </el-progress>
                        </div>
                        <div class="col-8 d-flex justify-content-center align-items-center ps-0">
                            <p class="mb-0">Este es el % al que deberías ir en tus cumplimientos a la fecha de hoy.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        </div>
            <div class="col-12 col-md-6 col-lg-6 d-flex align-items-center">
                <span class="nav-text d-flex">
                Navega entre las pestañas para conocer tu avance en los siguientes tres bloques.
                </span>
            </div>
        </div>
        <div class="container mb-5" id="tabsHome">
            <div class="col-12 col-sm-12 col-md-12">
                <div>
                    <div class="row  d-flex justify-content-start align-items-center">
                        <div class="col-4 col-md-2 ">
                            <span class="text-bat fs-6">Filtra por mes:</span>
                        </div>
                        <div class="col-8 col-md-6 justify-content-start">
                            <div v-if="available_client_months.length" class="month-filter float-start w-100">
                                <form>
                                    <select v-model="month">
                                        <option v-for="available_client_month in available_client_months" :value="available_client_month.month">
                                            {{ getMonthText(available_client_month.month) }}
                                        </option>
                                    </select>
                                </form>
                            </div>
                        </div>
                        <div v-if="unit_guide.length !== 0" class="col-12 col-md-4 mt-3 mt-md-0 d-flex justify-content-md-start justify-content-center">
                            <button class="bg-transparent border-0 " data-bs-toggle="modal" data-bs-target="#guiaDeUnidadesModal">
                                <img :src="unit_guide.icon" alt="Guia de unidades">
                                <span class="fs-6 text-indigo border-bottom text-title-bat">
                                    {{ unit_guide.title }}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Guia de Unidades -->
            <div class="modal fade" id="guiaDeUnidadesModal" tabindex="-1" aria-labelledby="guiaDeUnidadesModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-sm">
                    <div class="modal-content">
                    <div class="modal-header border-0">
                        <h1 class="modal-title fs-5" id="guiaDeUnidadesModalLabel">
                            {{ unit_guide.title }}
                        </h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                        <div class="modal-body border-0 d-flex justify-content-center">
                            <img class="img-fluid" :src="unit_guide.image" alt="guia-unidades">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container px-md-3 px-lg-5 px-sm-0 pt-5 text-bat">
            <div class="row tabs-vendedores">

                <div class=" col-12 col-sm-12 col-md-6">
                    <div class="tabs ">
                    <ul class="nav nav-pills mb-3 nav-justified" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" :class="principalOption === 'contigo'?'active':''" @click="setPrincipalOption('contigo')" data-bs-toggle="pill" type="button" role="tab">Contigo</button>
                        </li>
                        <li class="nav-item" role="presentation" v-if="segment_display_rv && segment_display_rv.active && segment_display_rv.active == 1" ref="targetElement">
                            <button class="nav-link" :class="principalOption === 'renta_variable'?'active':''" @click="setPrincipalOption('renta_variable')" data-bs-toggle="pill" type="button" role="tab">Renta Variable</button>
                        </li>
                        <li class="nav-item" role="presentation" v-if="validSegments()">
                            <button class="nav-link" :class="principalOption === 'bateadores'?'active':''" @click="setPrincipalOption('bateadores')" data-bs-toggle="pill" type="button" role="tab">BATeadores</button>
                        </li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="container px-md-3 px-lg-5 px-sm-1 py-2">
            <div class="tab-content contigo d-flex justify-content-center " id="pills-tabContent">

                <!-- Contigo -->
                <div v-if="principalOption === 'contigo'" class="cards-contigo">
                    <!-- Disclaimer Contigo Mobile inicio-->
                    <div class="d-block d-xl-none">
                        <div class="bg-white shadow-lg fixed-top p-2 m-2 text-bat rounded-4" v-show="showDiv">
                            <div class="row d-flex align-items-center justify-content-center">
                                <div class="col-2 d-flex align-items-center justify-content-center">
                                    <img src="/img-version2/icons/atention-msg.svg" alt="">
                                </div>
                                <div class="col-10">
                                    <p class="fw-bold mb-0 text-break fs-7">Este seguimiento es una herramienta de apoyo, <span class="text-danger text-title-bat">no implica ningún compromiso de pago por parte de BAT</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Disclaimer Contigo Mobile Final-->

                    <div v-if="data_contigo && data_contigo.metrics" class="mb-3">
                        <div class="row">
                            <!-- Disclaimer Renta Variable  inicio-->
                            <div class="d-none d-xl-block">
                                <div class="fixed-bottom w-50 row mx-auto">
                                    <div class="bg-white shadow-lg p-2 m-2 m-md-0 my-md-2 text-bat rounded-4">
                                        <div class="row d-flex align-items-center justify-content-center">
                                            <div class="col-2 d-flex align-items-center justify-content-end">
                                                <img src="/img-version2/icons/atention-msg.svg" alt="">
                                            </div>
                                            <div class="col-8">
                                                <p class="fw-bold mb-0 text-break fs-7 text-center">Este seguimiento es una herramienta de apoyo, <br> <span class="text-danger text-title-bat">no implica ningún compromiso de pago por parte de BAT</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Disclaimer Renta Variable  Final-->
                            <div v-for="item in data_contigo.metrics" class="col-12 col-sm-12 col-md-12 col-lg-6">
                            <!-- <div v-for="item in data_contigo.metrics"> -->
                                <div class="card-var position-relative">
                                    <div class="wrapper-var">
                                        <div class="box box1">
                                            <div class="box-content">
                                                <p class="variable-name">{{ item.kpi }}</p>
                                                <p class="text-advance">{{ numberFormat(item.real) }}</p>
                                                <el-progress class="variable-value" :percentage="(Number(item.advance) * 100) > 100 ? 100 : (Number(item.advance) * 100)" :show-text="false" :color="customColorMethod"></el-progress>
                                                <p class="text-advance">({{ Math.round(item.advance * 100) }}%)</p>
                                            </div>
                                        </div>
                                        <div class="box box2">
                                            <div class="box-content">
                                                <p class="rotulo">Objetivo</p>
                                                <p class="valor">{{ numberFormat(item.goal) }}</p>
                                            </div>
                                        </div>
                                        <div class="box box3">
                                            <div class="box-content">
                                                <p class="rotulo">Pendiente</p>
                                                <p class="valor">
                                                    {{ numberFormat(Number(item.goal) - Number(item.real) < 0 ? 0 : Number(item.goal) - Number(item.real)) }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="box box4 position-relative">
                                            <div class="box-content">
                                                <p class="rotulo">Puntos</p>
                                                <p class="valor">{{ numberFormat(item.saving_points) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="medicion">
                        <div class="col-12 col-md-5 col-lg-5 mb-4 ">
                            <a class="text-decoration-none text-secondary text-bat d-flex flex-row text-center aling-items-center border border-secondary rounded-4 justify-content-center py-2 px-2"  href="/novedades">
                                <img class="me-2" src="/img-version2/icons/Trending-up.svg" alt="">
                                <span class="me-2 text-title-bat">
                                    Entérate aquí sobre tu medición
                                </span>
                                <span>
                                    <b> ></b>
                                </span>
                            </a>
                        </div>

                    </div>
                </div>
                <!-- Fin Contigo -->

                <!-- Renta Variable NUEVO -->
                <div v-else-if="principalOption === 'renta_variable'">
                    <!-- Disclaimer Renta Variable Mobile inicio-->
                    <div class="d-block d-xl-none">
                        <div class="bg-white shadow-lg fixed-top p-2 m-2 text-bat rounded-4" v-show="showDiv">
                            <div class="row d-flex align-items-center justify-content-center">
                                <div class="col-2 d-flex align-items-center justify-content-center">
                                    <img src="/img-version2/icons/atention-msg.svg" alt="">
                                </div>
                                <div class="col-10">
                                    <p class="fw-bold mb-0 text-break fs-7">Este seguimiento de la renta variable es una herramienta de apoyo, <span class="text-danger text-title-bat">no implica ningún compromiso de pago por parte de BAT</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Disclaimer Renta Variable Mobile Final-->

                    <!-- Nuevas tabs -->
                    <div v-if="isGrouped" class="row">
                        <div v-if="showModalVariable">
                            <popups-variable-rent :closeModalRentVariable="closeModalRentVariable" :accelerators="accelerators"></popups-variable-rent>
                        </div>

                        <div v-if="hasValidRvData()">
                            <span class="text-bat">*El volumen o el número de pedidos puede variar de acuerdo con el procedimiento de las devoluciones.</span>
                            <h5 class="text-indigo-darkness text-title-bat mt-5">Seguimiento de Variables</h5>
                            <div class="check-var d-flex align-self-start d-flex align-items-start mt-3 text-bat">

                                <div class="mb-4">
                                    <a class="link-explanatory-popup text-bat" @click="showModalRentVariable">
                                        <img src="/img-version2/icons/activity.svg" alt="Icono">
                                        <span class="reference">Encuentra aquí las variables aceleradoras</span>
                                    </a>
                                </div>
                            </div>

                            <div class="tabs-channels col-12 col-sm-12 col-md-6 mb-3">
                                <button
                                    class="tab"
                                    :class="{ active: activeTab === 'WHS' }"
                                    @click="activeTab = 'WHS'"
                                >
                                    WHS
                                </button>
                                <button
                                    class="tab"
                                    :class="{ active: activeTab === 'RETAIL' }"
                                    @click="activeTab = 'RETAIL'"
                                >
                                    RETAIL
                                </button>
                            </div>

                            <metrics-rv
                                :data_rv="data_rv"
                                :isGrouped="isGrouped"
                                :activeTab="activeTab"
                                :segment_display_rv="segment_display_rv"
                                :accelerators="accelerators"
                                :payments_rv="payments_rv"
                            ></metrics-rv>
                        </div>
                        <div v-else class="msj-error mt-4">
                            <div class="content d-flex align-items-start p-2">
                                <p class="mb-0"> Por cambio en la estructura del modelo de <strong>renta variable</strong>, no es posible ver el histórico de meses anteriores en la plataforma.</p>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <div v-if="hasValidRvData()">
                            <div v-if="showModalVariable">
                                <popups-variable-rent :closeModalRentVariable="closeModalRentVariable" :accelerators="accelerators"></popups-variable-rent>
                            </div>

                            <div v-if="data_rv && data_rv.metrics_totals && data_rv.metrics_totals.update_date && segment_display_rv.segment != 15" class="text-bat mt-3">
                                <p>Los datos de estas variables fueron actualizados con corte de ventas al <strong>{{ formatDate(data_rv.metrics_totals.update_date) }}</strong></p>
                            </div>

                            <div v-if="data_rv && data_rv.metrics && data_rv.metrics.length > 0">
                                <span class="text-bat">*El volumen o el número de pedidos puede variar de acuerdo con el procedimiento de las devoluciones.</span>
                                <h5 class="text-indigo-darkness text-title-bat mt-5">Seguimiento de Variables</h5>
                                <div class="check-var d-flex align-self-start d-flex align-items-start mt-3 text-bat">

                                    <div class="mb-4">
                                        <a class="link-explanatory-popup text-bat" @click="showModalRentVariable">
                                            <img src="/img-version2/icons/activity.svg" alt="Icono">
                                            <span class="reference">Encuentra aquí las variables aceleradoras</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <metrics-rv
                                :data_rv="data_rv"
                                :isGrouped="isGrouped"
                                :activeTab="activeTab"
                                :segment_display_rv="segment_display_rv"
                                :accelerators="accelerators"
                                :payments_rv="payments_rv"
                            ></metrics-rv>
                        </div>
                        <div v-else class="msj-error mt-4">
                            <div class="content d-flex align-items-start p-2">
                                <p class="mb-0"> Por cambio en la estructura del modelo de <strong>renta variable</strong>, no es posible ver el histórico de meses anteriores en la plataforma.</p>
                            </div>
                        </div>
                    </div>

                    <div v-if="hidden_simulator === false" class="simulador mt-5">
                        <div class="content">
                            <h2>Simulador de Renta Variable</h2>
                            <p>¡En este simulador podrás calcular la mejor manera de alcanzar tus metas de renta variable, para que nunca te quedes corto! </p>
                            <div class="row d-flex justify-content-between">
                                <div class="col-12 col-lg-6 col-md-6">
                                    <p>Ingresa los datos en cada campo disponible y al finalizar haz click en <strong>"Aceptar"</strong> para ver el resultado.</p>
                                </div>
                                <div class="col-12 col-lg-6 col-md-6 d-flex justify-content-sm-center justify-content-start">
                                    <a @click="getView">Ver simulador >></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Fin Renta Variable NUEVO -->

                <!-- Bateadores -->
                <div v-else-if="principalOption === 'bateadores' && data_bateadores.metrics" class="container">
                    <!-- Disclaimer Bateadores Mobile inicio-->
                    <div class="d-block d-xl-none">
                        <div class="bg-white shadow-lg fixed-top p-2 m-2 text-bat rounded-4" v-show="showDiv">
                            <div class="row d-flex align-items-center justify-content-center">
                                <div class="col-2 d-flex align-items-center justify-content-center">
                                    <img src="/img-version2/icons/atention-msg.svg" alt="">
                                </div>
                                <div class="col-10">
                                    <p class="fw-bold mb-0 text-break fs-7">Este seguimiento es una herramienta de apoyo, <span class="text-danger text-title-bat">no implica ningún compromiso de pago por parte de BAT</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Disclaimer Bateadores Mobile Final-->

                    <!-- Disclaimer Renta Variable  inicio-->
                    <div class="d-none d-xl-block">
                        <div class="fixed-bottom w-50 row mx-auto">
                            <div class="bg-white shadow-lg p-2 m-2 m-md-0 my-md-2 text-bat rounded-4">
                                <div class="row d-flex align-items-center justify-content-center">
                                    <div class="col-2 d-flex align-items-center justify-content-end">
                                        <img src="/img-version2/icons/atention-msg.svg" alt="">
                                    </div>
                                    <div class="col-8">
                                        <p class="fw-bold mb-0 text-break fs-7 text-center">Este seguimiento es una herramienta de apoyo, <br> <span class="text-danger text-title-bat">no implica ningún compromiso de pago por parte de BAT</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Disclaimer Renta Variable  Final-->

                    <!-- Bateadores nuevo diseño-->
                    <div>
                        <!-- Pestañas de Ligas -->
                        <ul class="custom-tabs d-flex justify-content-center justify-content-md-start gap-3 list-unstyled p-0 text-bat">
                            <li v-for="(league, index) in leagues" :key="index" class="custom-tab-item" @click="activeTabBAT = league.id">
                                <a class="custom-tab-link" :class="{ 'active': activeTabBAT === league.id }">
                                    <img class="d-block d-md-none" :src="league.iconMobile" :alt="league.name">
                                    <img class="d-none d-md-block" :src="league.iconDesktop" :alt="league.name">
                                    <strong>{{ league.name }}</strong>
                                </a>
                            </li>
                        </ul>

                        <div v-if="activeTabBAT">
                            <div v-for="league in leagues" :key="league.id" v-if="league.id === activeTabBAT">
                                <!-- Descripción -->
                                <div v-if="(activeTabBAT === 3 && hasBronzeData) || (activeTabBAT === 2 && hasSilverData) || (activeTabBAT === 1 && hasGoldData)">
                                    <div class="text-bat my-3">
                                        <h5>Compite, sube de nivel y alcanza la cima.</h5>
                                        <h6 class="text-bat">El ranking es dinámico y puede cambiar según el desempeño de los participantes.</h6>
                                    </div>

                                    <!-- Contenido de la liga -->
                                    <div class="tab-content text-center">
                                        <div class="show active">
                                            <!-- Días restantes -->
                                            <div v-if="selectedLeague" class="d-flex">
                                                <span class="my-2 rounded-5 border border-info text-info px-2 py-1 text-btn-outstanding d-flex align-items-center">
                                                    <img class="mx-1" src="/img/icons/clock_win_points.svg" alt="vencimiento">Quedan {{ daysRemaining  }} días
                                                </span>
                                            </div>

                                            <!-- Lista de Ranking -->
                                            <ul class="ranking-list mt-3 px-0">
                                                <li v-for="(jugador, jIndex) in filteredRanking" :key="jIndex" class="ranking-item d-flex align-items-center justify-content-between" :class="{'ranking-first': jIndex === 0, 'ranking-second': jIndex === 1, 'ranking-third': jIndex === 2}">
                                                    <div class="d-flex align-items-center">
                                                        <span class="medal-icon" :class="{'medal-large': jIndex === 0, 'medal-medium': jIndex === 1, 'medal-small': jIndex === 2}">
                                                            <img :src="getMedalIcon(league.name)" alt="medalla">                                                        </span>
                                                        <strong class="player-name ms-2 text-start">
                                                           {{ formatName(jugador.client.user.name) }} <span v-if="jugador.client.id === clientId" class="text-muted">(Tú)</span>
                                                        </strong>
                                                    </div>
                                                </li>
                                            </ul>

                                            <!-- Aviso si el usuario aún no está en ranking -->
                                            <div v-if="(activeTabBAT === 3 && !isInRanking.bronze) || (activeTabBAT === 2 && !isInRanking.silver) || (activeTabBAT === 1 && !isInRanking.gold)" class="not-in-ranking mt-5 p-3 rounded border">
                                                <h6 class="text-indigo text-bat" style="text-align: justify;"><strong>Sigue mejorando día a día</strong></h6>
                                                <h6 class="text-bat text-start">¡Te falta <strong>{{ getClientPercentageForLeague(selectedLeague.name) }}</strong> para tener la posibilidad de ingresar al ranking! Sigue avanzando en el cumplimiento de tus objetivos mensuales de renta variable.</h6>
                                                <div class="ranking-me ranking-item player-progress d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <span class="medal-icon ms-2 medal-small">
                                                            <img :src="getMedalIcon(league.name)" alt="medalla">
                                                        </span>
                                                        <strong class="ms-2 text-start">{{ formatName(clientName) }} <span class="text-muted">(Tú)</span></strong>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="px-0 mt-4 p-3 d-flex justify-content-center justify-content-md-start d-none">
                                                <button class="custom-btn btn text-title-bat rounded-3 btn-season mx-1">
                                                    <span>Ir al Hall de la Fama</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Mostrar mensaje si el ranking está vacío -->
                                <div v-else class="col-12 col-md-6">
                                    <h5 class="text-title-bat text-indigo custom-text-align">Podium {{league.name}} </h5>

                                    <div v-if="league.name === 'Bronce'" class="mt-3 text-bat custom-text-align">
                                        <h6 class="text-bat">Conoce el tiempo restante para entrar en el podium este trimestre.</h6>
                                    </div>
                                    <div v-else-if="league.name === 'Plata'" class="mt-3 text-bat custom-text-align">
                                        <h6 class="text-bat">Podium Plata <strong>reconocerá a quienes tengan los mejores</strong> promedios de renta variable semestralmente, por encima del 105% del pago.</h6>
                                    </div>
                                    <div v-else-if="league.name === 'Oro'" class="mt-3 text-bat custom-text-align">
                                        <h6 class="text-bat">Podium Oro <strong>reconocerá al mejor</strong> promedio de renta variable anual. </h6>
                                    </div>

                                    <div style="border-left: 4px solid var(--Semantic-Danger-100, #F00); background: #FFDED9; padding: 10px;" class="mt-3 text-bat">
                                        <p class="mb-0">
                                            <span v-if="league.name === 'Bronce' || league.name === 'Plata' || league.name === 'Oro'">
                                                <span v-if="league.next_upload">
                                                    Consulta tu ranking a partir del <strong>{{ formatDate(league.next_upload) }}.</strong>
                                                </span>
                                                <span v-else>
                                                    Espera más información próximamente.
                                                </span>
                                            </span>
                                            <span v-else>
                                                Espera más información próximamente.
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Fin Bateadores -->
            </div>
        </div>

        <div class="modal fade modal-conversion" id="tableModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Tabla de equivalentes</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">Cerrar</button>
                    </div>
                    <div class="modal-body">
                        <table v-if="payments_rv" class="table table-conversion table-bordered align-center">
                            <thead>
                                <tr class="header">
                                <th scope="col">Sumatoria</th>
                                <th scope="col">Pago R.V.</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Fila adicional para "Menor al primer cumplimiento" con 0% -->
                                <tr>
                                    <td scope="row">Menor a {{ payments_rv[0].accomplishment }}%</td>
                                    <td>0%</td>
                                </tr>
                                <!-- Resto de las filas -->
                                <tr v-for="(payment, index) in payments_rv" :key="index">
                                    <td scope="row">
                                        {{ index === payments_rv.length - 1 ? `Mayor a ${payment.accomplishment}%` :
                                            `${payment.accomplishment}%`
                                        }}
                                    </td>
                                    <td>{{ payment.rv_payment }}%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { isInteger } from 'lodash';

export default {
    props: {
        identification_number: {
            default: null,
        },
        selected_month: {
            default: null,
        },
        selected_year: {
            default: null,
        },
        current_view: {
            default: null,
        },
        hidden_simulator: {
            default: false,
        },
        hidden_title: {
            default: false,
        },
        hidden_rent: {
            default: false,
        },
        segment_display_rv: {
            default: null,
        },
        accelerators: {
            default: null,
        },
        payments_rv: {
            default: null,
        },
    },
    data() {
        return {
            available_client_months: [],
            data_contigo: [],
            data_rv: [],
            data_bateadores: [],
            ranking: [],
            current_ranking: [],

            award: 0,
            state_collection: '',
            state_message: '',
            // state_message_channels:'',
            final_accomplishment: 0,
            rv_result: 0,

            month: null,
            year: null,
            view: 'simulator',
            principalOption: 'contigo',
            rvOption: 'vuse',
            showDiv: false,
            advanceWorkingDays: 0,
            non_working_days: null,
            customColorWorkDays: '#12C2E9',

            currentDate: null,
            currentDay: null,
            currentMonth: null,
            currentYear: null,

            unit_guide: [],
            total_award: 0,
            total_expected: 0,

            showModalVariable: false,
            showModalPopupsWildcard: false,

            countModalRentVariable: 0,

            activeTab: 'WHS',
            isGrouped: false,
            activeTabBAT: 3,
            leagues: [],
            hasLeaguesData: false,
            rankingBAT: {
                bronze: [],
                silver: [],
                gold: []
            },
            clientId: null,
            isInRanking: {
                bronze: false,
                silver: false,
                gold: false
            },
            clientPositions: {
                bronze: null,
                silver: null,
                gold: null
            },
            clientPercentage: {
                bronze: null,
                silver: null,
                gold: null
            },
            clientSegmentationId: null
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);

        if(this.selected_month) {
            this.month = this.selected_month
        }

        // Obtener Data
        this.month = this.selected_month
        this.year = this.selected_year

        this.getData()
        this.non_working_days = this.getNonWorkingDays()

        this.currentDate = new Date();
        this.currentDay = this.currentDate.getDate();
        this.currentMonth = this.currentDate.getMonth() + 1;
        this.currentYear = this.currentDate.getFullYear();
        this.getUnitGuideData();
        this.getLeaguesData();
    },
    created (){
        const urlParams = new URLSearchParams(window.location.search);
        this.principalOption = urlParams.get('tab') || 'contigo';

        if (this.principalOption === 'bateadores'){
            this.setPrincipalOption(this.principalOption);
        }
    },
    watch: {
        currentDay: function() {
            this.calculateAdvance()
        },
        currentMonth: function() {
            this.calculateAdvance()
        },
        currentYear: function() {
            this.calculateAdvance()
        },
        month: function() {
            this.getData()
        },
        selected_month: function() {
            this.month = this.selected_month
        },
        data_rv: {
            deep: true,
            handler(new_data_rv, old_data_rv) {
                // this.calculateJoker()
                // this.hasValidRvData()
                this.calculateTotalAward()
                this.calculateFinalAccomplishment()
                this.calculateResult()
                this.isGroupedByChannel()
            }
        },
        activeTabBAT(newTab) {
            this.getLeaguesData();
            this.updateFilteredRanking();
        }
    },
    computed: {
        selectedLeague() {
            return this.leagues.find(league => league.id === this.activeTabBAT);
        },
        daysRemaining() {
            if (this.selectedLeague) {
                return this.calculateRemainingDays(this.selectedLeague.date_finish);
            }
            return null;
        },
        filteredRanking() {
            if (!this.selectedLeague || !this.selectedLeague.name) return [];

            const leagueName = this.selectedLeague.name.toLowerCase();
            const leagueIds = {
                'bronce': 3,
                'plata': 2,
                'oro': 1
            };

            const filtered = this.rankingBAT.filter(jugador => jugador.league_id === leagueIds[leagueName]);

            return filtered;
        }
    },
    methods: {
        hasValidRvData() {
            if(this.isGrouped) {
                return this.data_rv && this.data_rv.metrics && Object.keys(this.data_rv.metrics).length > 1
            } else {
                return this.data_rv && this.data_rv.metrics && this.data_rv.metrics.length > 0
            }
        },
        isGroupedByChannel() {
            // Verifica si `metrics` es un objeto con claves representando los canales
            this.isGrouped = typeof this.data_rv.metrics === 'object' &&
                                !Array.isArray(this.data_rv.metrics) &&
                                Object.keys(this.data_rv.metrics).length > 0 &&
                                Object.values(this.data_rv.metrics).every(item => Array.isArray(item));
        },
        setPrincipalOption(option) {
            this.principalOption = option
            if(this.principalOption == 'renta_variable') {
                this.updateProgressFinalRV();
                if(this.countModalRentVariable == 0) {
                    this.showModalRentVariable();
                    this.countModalRentVariable = 1;
                }
            }
        },
        getNonWorkingDays() {
            axios.get(`/get-non-working-days`)
                 .then(({data}) => {
                     this.non_working_days = data.non_working_days
                     this.calculateAdvance()
                 })
        },
        isHoliday(dateToAnalyze) {
            // Se determina el dia, mes y año de la fecha a analizar
            const selectedDate = new Date(dateToAnalyze);
            const selectedDay = selectedDate.getDate();
            const selectedMonth = selectedDate.getMonth() + 1;
            const selectedYear = selectedDate.getFullYear();

            // Se determina si es dia no laborable personalizado
            if(this.non_working_days && this.non_working_days.length > 0) {
                if(this.non_working_days.includes(dateToAnalyze)) {
                    return true;
                }
            }

            // Se determina si es sábado o domingo
            const dayWeek = selectedDate.getDay();
            if(dayWeek === 0 || dayWeek === 6) {
                return true;
            }

            // Se determina si selectedDate pertenece a los dias festivos de fecha fija en Colombia
            if(
                (selectedDay === 1 && selectedMonth === 1) ||
                (selectedDay === 1 && selectedMonth === 5) ||
                (selectedDay === 20 && selectedMonth === 7) ||
                (selectedDay === 7 && selectedMonth === 8) ||
                (selectedDay === 8 && selectedMonth === 12) ||
                (selectedDay === 25 && selectedMonth === 12)
            ) {
                return true;
            }

            // Se determina si selectedDate es festivo de primer lunes
            const dayWeekSelectedDate = selectedDate.getDay();
            if(dayWeekSelectedDate === 1) {
                if(
                    (selectedDay === 6 && selectedMonth === 1) ||
                    (selectedDay === 19 && selectedMonth === 3) ||
                    (selectedDay === 29 && selectedMonth === 6) ||
                    (selectedDay === 15 && selectedMonth === 8) ||
                    (selectedDay === 12 && selectedMonth === 10) ||
                    (selectedDay === 1 && selectedMonth === 11) ||
                    (selectedDay === 11 && selectedMonth === 11)
                ) {
                    return true;
                } else {
                    for (let i = 6; i > 0; i--) {
                        const mlsDiff = i * 24 * 60 * 60000;
                        const mls = selectedDate.getTime();
                        const newSelectedDate = new Date(mls - mlsDiff);

                        const newSelectedDay = newSelectedDate.getDate();
                        const newSelectedMonth = newSelectedDate.getMonth() + 1;
                        const newSelectedYear = newSelectedDate.getFullYear();

                        if(
                            (newSelectedDay === 6 && newSelectedMonth === 1) ||
                            (newSelectedDay === 19 && newSelectedMonth === 3) ||
                            (newSelectedDay === 29 && newSelectedMonth === 6) ||
                            (newSelectedDay === 15 && newSelectedMonth === 8) ||
                            (newSelectedDay === 12 && newSelectedMonth === 10) ||
                            (newSelectedDay === 1 && newSelectedMonth === 11) ||
                            (newSelectedDay === 11 && newSelectedMonth === 11)
                        ) {
                            return true;
                        }
                    }
                }
            }

            // Se determina si selectedDate es festivo de pascua
            if(selectedMonth === 3 || selectedMonth === 4 || selectedMonth === 5 || selectedMonth === 6 || selectedMonth === 7) {
                let M = 0;
                let N = 0;
                if(selectedYear >= 1900 && selectedYear <= 2099) {
                    M = 24;
                    N = 5;
                } else if(selectedYear >= 2100 && selectedYear <= 2199) {
                    M = 24;
                    N = 6;
                } else if(selectedYear >= 2200 && selectedYear <= 2299) {
                    M = 25;
                    N = 0;
                }

                const a = selectedYear % 19;
                const b = selectedYear % 4;
                const c = selectedYear % 7;
                const d = ((19 * a) + M) % 30;
                const e = ((2 * b) + (4 * c) + (6 * d) + N) % 7;

                let diaPascua = 0;
                let mesPascua = 0;
                if((d + e) < 10) {
                    diaPascua = d + e + 22;
                    mesPascua = 3;
                } else if((d + e) >= 10) {
                    diaPascua = d + e - 9;
                    mesPascua = 4;

                    if(diaPascua === 26) {
                        diaPascua  = 19;
                    } else if((diaPascua === 25) && (d === 28) && (e === 6) && (a > 10)) {
                        diaPascua  = 18;
                    }
                }

                const domingoDePascua = new Date(selectedYear + "/" + mesPascua + "/" + diaPascua);
                const domingoDeRamos = new Date(domingoDePascua.getTime() - 604800000);
                const juevesSanto = new Date(domingoDePascua.getTime() - 259200000);
                const viernesSanto = new Date(domingoDePascua.getTime() - 172800000);
                const ascencion = new Date(domingoDePascua.getTime() + 3715200000);
                const corpus = new Date(domingoDePascua.getTime() + 5529600000);
                const sagradoCorazon = new Date(domingoDePascua.getTime() + 6134400000);

                if(
                    selectedDate.getTime() === domingoDePascua.getTime() ||
                    selectedDate.getTime() === domingoDeRamos.getTime() ||
                    selectedDate.getTime() === juevesSanto.getTime() ||
                    selectedDate.getTime() === viernesSanto.getTime() ||
                    selectedDate.getTime() === ascencion.getTime() ||
                    selectedDate.getTime() === corpus.getTime() ||
                    selectedDate.getTime() === sagradoCorazon.getTime()
                ) {
                    return true;
                }
            }
            return false;
        },
        calculateAdvance() {
            // Se determina el dia, mes y año en curso
            const currentDate = new Date(this.currentYear + '/' + this.currentMonth + '/' + this.currentDay);
            const currentDay = currentDate.getDate();
            const currentMonth = currentDate.getMonth() + 1;
            const currentYear = currentDate.getFullYear();

            // Se determina la cantidad de dias del mes en curso
            const daysInCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

            let totalWorkingDays = 0;
            let currentWorkingDays = 0;
            let dayOfMonth = '';
            for (let i = 1; i <= daysInCurrentMonth; i++) {
                let isHoliday = false;   // false: Día hábil
                let digitDay;
                let digitMonth;

                // Se establece el dia a dos digitos
                digitDay = i < 10 ? `0${i}` : `${i}`;

                // Se establece el mes a dos digitos
                digitMonth = currentMonth < 10 ? `0${currentMonth}` : `${currentMonth}`;

                dayOfMonth = currentYear + '/' + digitMonth + '/' + digitDay;

                isHoliday  = this.isHoliday(dayOfMonth);

                if(!isHoliday) {
                    totalWorkingDays++;
                    if(i <= currentDay) {
                        currentWorkingDays++;
                    }
                }
            }

            this.advanceWorkingDays = currentWorkingDays / totalWorkingDays;
        },
        handleScroll() {
            // Obtener la posición del elemento específico
            const targetElementPosition = this.$refs.targetElement.offsetTop;

            // Obtener la posición actual de desplazamiento vertical
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            // Verificar si la posición de desplazamiento alcanza el elemento específico
            if (scrollPosition >= targetElementPosition) {
                this.showDiv = true;
            } else {
                this.showDiv = false;
            }
        },
        getTypeVariable(cadena) {
            if(cadena.includes('$')) {
                return true;
            } else {
                return false;
            }
        },
        getView() {
            this.$emit('getView', this.view)
            window.scrollTo(0, 0);
        },
        getData() {
            this.loading++
            const months_not_allowed = [1,2,3,4,5,6]
            axios.get(`/get-home-from-api-result?identification=${this.identification_number}&month=${this.month}&year=${this.year}`)
                 .then(({data}) => {
                    this.available_client_months = data.available_client_months
                    this.data_contigo = data.data_contigo

                    if(this.year == 2023) {
                        if(!months_not_allowed.includes(this.month)) {
                            this.data_rv = data.data_rv
                        } else {
                            this.data_rv = []
                        }
                    } else {
                        this.data_rv = data.data_rv
                    }

                    this.data_bateadores = data.data_bateadores
                    this.ranking = data.ranking
                    this.current_ranking = data.current_ranking
                    if(this.hidden_rent === false){
                        this.updateProgressFinalRV()
                    }
                    if(this.data_rv && this.data_rv.metrics_totals && Object.keys(this.data_rv.metrics_totals).length !== 0) {
                        this.accomplishment = this.data_rv.metrics_totals.accomplishment
                        if(this.data_rv.metrics_totals.advance_collection) {
                            // this.calculateJoker()
                            // this.calculateAward()
                            this.calculateTotalAward();
                            this.calculateFinalAccomplishment()
                        }
                    }
                    this.loading--
                })
        },
        getMonthText(month) {
            switch (month) {
                case 1:
                    return 'Enero';
                    break;

                case 2:
                    return 'Febrero';
                    break;

                case 3:
                    return 'Marzo';
                    break;

                case 4:
                    return 'Abril';
                    break;

                case 5:
                    return 'Mayo';
                    break;

                case 6:
                    return 'Junio';
                    break;

                case 7:
                    return 'Julio';
                    break;

                case 8:
                    return 'Agosto';
                    break;

                case 9:
                    return 'Septiembre';
                    break;

                case 10:
                    return 'Octubre';
                    break;

                case 11:
                    return 'Noviembre';
                    break;

                case 12:
                    return 'Diciembre';
                    break;

                default:
                    break;
            }
        },
        customColorMethod(percentage) {
            if (percentage >= 100) {
                return 'green';
            } else if (percentage >= 90 && percentage < 100) {
                return 'orange';
            } else {
                return 'red';
            }
        },
        customColorMethodCollection(percentage) {
            if (percentage >= 100) {
                return 'green';
            } else if (this.data_rv && percentage >= (Math.round(Number(this.data_rv.metrics_totals.target_threshold) * 10000) / 100) && percentage < 100) {
                return 'orange';
            } else {
                return 'red';
            }
        },
        customColorMethodRV(advance, accelerator) {
            if (advance < 0.9) {
                return 'red';
            } else if (advance >= 0.9 && advance < 1) {
                return 'orange';
            }

            if (accelerator == 0) {
                if (advance >= 1) {
                    return 'green';
                }
            } else if (accelerator == 1) {
                if (advance >= 1 && advance < (this.accelerators[0].value / 100)) {
                    return 'green';
                } else if (advance >= (this.accelerators[0].value / 100)) {
                    return '#00B5F3';
                }
            } else if (accelerator == 2) {
                if (advance >= 1 && advance < (this.accelerators[1].value / 100)) {
                    return 'green';
                } else if (advance >= (this.accelerators[1].value / 100)) {
                    return '#5A1E85';
                }
            }
        },
        numberFormat(number) {
            const exp = /(\d)(?=(\d{3})+(?!\d))/g
            const rep = '$1.'
            let arr = number.toString().split('.')
            arr[0] = arr[0].replace(exp,rep)
            return arr[1] ? arr.join(','): arr[0]
        },
        getState() {
            //
        },
        calculateTotalAward() {
            let totalAward = 0;
            let totalAwardExpected = 0;
            if(this.data_rv.metrics_awards) {
                for (let i = 0; i < this.data_rv.metrics_awards.length; i++) {
                    if(this.data_rv.metrics_awards[i].value && Number(this.data_rv.metrics_awards[i].advance) >= 1 ) {
                        totalAward += Number(this.data_rv.metrics_awards[i].value);
                    }
                    totalAwardExpected += Number(this.data_rv.metrics_awards[i].value);
                }
            }
            this.total_award = totalAward;
            this.total_expected = totalAwardExpected;
        },
        calculateFinalAccomplishment() {
            this.calculateTotalAward()
            if(this.data_rv.metrics_totals.accomplishment) {
                this.final_accomplishment = (Number(this.data_rv.metrics_totals.accomplishment) * 100) + (Number(this.total_award) * 100)
            }

            if(this.data_rv.metrics_totals && this.data_rv.metrics_totals.advance_collection < Number(this.data_rv.metrics_totals.target_threshold)) {
                this.state_collection = 'red-semaforo'
                this.state_message = 'msj-semaforo-red'
                // this.state_message_channels = 'msj-semaforo-red-channels'
            } else {
                this.state_collection = 'green-semaforo'
                this.state_message = 'msj-semaforo-green'
            }
        },
        calculateResult() {
            let acc_rv = this.final_accomplishment
            if(acc_rv >= -999 && acc_rv < 90) {
                this.rv_result = 0
            } else if (acc_rv >= 90 && acc_rv < 91) {
                this.rv_result = 50
            } else if (acc_rv >= 91 && acc_rv < 92) {
                this.rv_result = 55
            } else if (acc_rv >= 92 && acc_rv < 93) {
                this.rv_result = 60
            } else if (acc_rv >= 93 && acc_rv < 94) {
                this.rv_result = 65
            } else if (acc_rv >= 94 && acc_rv < 95) {
                this.rv_result = 70
            } else if (acc_rv >= 95 && acc_rv < 96) {
                this.rv_result = 75
            } else if (acc_rv >= 96 && acc_rv < 97) {
                this.rv_result = 80
            } else if (acc_rv >= 97 && acc_rv < 98) {
                this.rv_result = 85
            } else if (acc_rv >= 98 && acc_rv < 99) {
                this.rv_result = 90
            } else if (acc_rv >= 99 && acc_rv < 100) {
                this.rv_result = 95
            } else if (acc_rv >= 100 && acc_rv < 101) {
                this.rv_result = 100
            } else if (acc_rv >= 101 && acc_rv < 102) {
                this.rv_result = 110
            } else if (acc_rv >= 102 && acc_rv < 103) {
                this.rv_result = 120
            } else if (acc_rv >= 103 && acc_rv < 104) {
                this.rv_result = 130
            } else if (acc_rv >= 104 && acc_rv < 105) {
                this.rv_result = 140
            } else if (acc_rv >= 105) {
                this.rv_result = 150
            } else {
                //
            }

            if(this.data_rv.metrics_totals && this.data_rv.metrics_totals.advance_collection < Number(this.data_rv.metrics_totals.target_threshold) && this.segment_display_rv && this.segment_display_rv.penalty) {
                this.rv_result = Math.round(this.rv_result * (1 - (this.segment_display_rv.penalty / 100)))
            }

            this.updateProgressFinalRV()
        },
        formatDate(date){
            const newDate = new Date(date)
            return `${newDate.getDate()}/${newDate.getMonth()+1 < 10 ?`0${newDate.getMonth()+1}`: newDate.getMonth()+1 }/${newDate.getFullYear()}`
        },
        updateProgressFinalRV() {
            setTimeout(() => {
                let numero = this.$refs.numero
                let point = this.$refs.point
                let star = this.$refs.star
                let val = 0
                let stop1 = this.$refs.stop1
                let stop2 = this.$refs.stop2

                if(this.rv_result) {
                    val = this.rv_result
                }

                if(numero && val) {
                    let svgId = this.$refs.circle
                    let numero2 = (parseInt(val) *  170) / 150
                    svgId.style.transform = `translate(-50% , -50%) rotate(${numero2}deg)`
                    point.style.transform = `translate(-50% , -50%) rotate(${numero2}deg)`
                    if (parseInt(val) <= 0){
                        stop1.setAttribute("stop-color", "#A8A8A8");
                        stop2.setAttribute("stop-color", "#605B63");
                        numero.style.backgroundImage = '-webkit-linear-gradient(180deg, #A8A8A8 0%, #605B63 97.64%)';

                        point.classList.remove("red")
                        point.classList.remove("orange")
                        point.classList.remove("green")
                        point.classList.add("d-none")

                        star.classList.remove("active")
                        star.classList.add("disabled")
                    } else if (parseInt(val) > 0 && parseInt(val) < 50){
                        stop1.setAttribute("stop-color", "#ff9999");
                        stop2.setAttribute("stop-color", "#ff0000");
                        numero.style.backgroundImage = '-webkit-linear-gradient(180deg, #ff9999 0%, #ff0000 97.64%)';

                        point.classList.add("red")
                        point.classList.remove("orange")
                        point.classList.remove("green")
                        point.classList.remove("d-none")

                        star.classList.remove("active")
                        star.classList.add("disabled")
                    } else if (parseInt(val) >= 50 && parseInt(val) < 100){
                        stop1.setAttribute("stop-color", "#FFD600");
                        stop2.setAttribute("stop-color", "#F87C00");
                        numero.style.backgroundImage = '-webkit-linear-gradient(180deg, #FFD600 0%, #F87C00 97.64%)';

                        point.classList.remove("red")
                        point.classList.add("orange")
                        point.classList.remove("green")
                        point.classList.remove("d-none")

                        star.classList.remove("active")
                        star.classList.add("disabled")
                    } else if (parseInt(val) >= 100){
                        stop1.setAttribute("stop-color", "#6AC11F");
                        stop2.setAttribute("stop-color", "#00660A");
                        numero.style.backgroundImage = '-webkit-linear-gradient(180deg, #6AC11F 0%, #00660A 97.64%)';

                        point.classList.remove("red")
                        point.classList.remove("orange")
                        point.classList.add("green")
                        point.classList.remove("d-none")

                        star.classList.add("active")
                        star.classList.remove("disabled")
                    }
                }
            }, 200);
        },
        getUnitGuideData() {
            axios
                .get(
                    `get-unit-guide`
                )
                .then(({ data }) => {
                    this.unit_guide = data.unit_guide;
                });
        },
        showModalRentVariable() {
            this.showModalVariable = true
        },
        showModalWildcard() {
            this.showModalPopupsWildcard = true
        },
        closeModalRentVariable() {
            this.showModalVariable = false
        },
        closeModalWildcard() {
            this.showModalPopupsWildcard = false
        },
        getLeaguesData() {
            this.loading++;
            axios.get('/get-leagues-data')
                .then(response => {
                    const data = response.data;

                    if (data.data && data.data.client) {
                        this.clientId = data.data.client.id;
                        this.clientSegmentationId = data.data.client.segmentation_id
                        this.clientName = data.data.client.name;
                        this.clientPositions = {
                            bronze: data.data.client.bronze_position,
                            silver: data.data.client.silver_position,
                            gold: data.data.client.gold_position
                        };
                        this.clientPercentage = {
                            bronze: data.data.client.bronze_missing_points,
                            silver: data.data.client.silver_missing_points,
                            gold: data.data.client.gold_missing_points
                        };
                    } else {
                        console.error("El cliente no está definido");
                        this.clientId = null;
                        this.clientName = "Usuario desconocido";
                        this.clientPositions = { bronze: null, silver: null, gold: null };
                        this.clientPercentage = { bronze: null, silver: null, gold: null };

                    }

                    this.rankingBAT = {
                        bronze: Array.isArray(data.data.bronze?.data) ? data.data.bronze.data : [],
                        silver: Array.isArray(data.data.silver?.data) ? data.data.silver.data : [],
                        gold: Array.isArray(data.data.gold?.data) ? data.data.gold.data : []
                    };

                    this.isInRanking = {
                        bronze: this.rankingBAT.bronze.slice(0, 3).some(jugador => jugador.client_id === this.clientId),
                        silver: this.rankingBAT.silver.slice(0, 3).some(jugador => jugador.client_id === this.clientId),
                        gold: this.rankingBAT.gold.slice(0, 3).some(jugador => jugador.client_id === this.clientId)
                    };

                    const leagueData = {
                        'Oro': { name: 'Oro', iconMobile: '/../img-version2/icons/bateadores/medal_gold.png', iconDesktop: '/../img-version2/icons/bateadores/medal_gold_desktop.png' },
                        'Plata': { name: 'Plata', iconMobile: '/../img-version2/icons/bateadores/medal_silver.png', iconDesktop: '/../img-version2/icons/bateadores/medal_silver_desktop.png' },
                        'Bronce': { name: 'Bronce', iconMobile: '/../img-version2/icons/bateadores/medal_bronze.png', iconDesktop: '/../img-version2/icons/bateadores/medal_bronze_desktop.png' }
                    };

                    this.leagues = [
                        { id: 3, name: leagueData['Bronce'].name, iconMobile: leagueData['Bronce'].iconMobile, iconDesktop: leagueData['Bronce'].iconDesktop, date_finish: data.data.bronze?.date_finish, next_upload: data.data.bronze?.next_upload },
                        { id: 2, name: leagueData['Plata'].name, iconMobile: leagueData['Plata'].iconMobile, iconDesktop: leagueData['Plata'].iconDesktop, date_finish: data.data.silver?.date_finish, next_upload: data.data.silver?.next_upload },
                        { id: 1, name: leagueData['Oro'].name, iconMobile: leagueData['Oro'].iconMobile, iconDesktop: leagueData['Oro'].iconDesktop, date_finish: data.data.gold?.date_finish, next_upload: data.data.gold?.next_upload }
                    ];

                    this.hasBronzeData = Array.isArray(data.data.bronze?.data) && data.data.bronze.data.length > 0;
                    this.hasSilverData = Array.isArray(data.data.silver?.data) && data.data.silver.data.length > 0;
                    this.hasGoldData = Array.isArray(data.data.gold?.data) && data.data.gold.data.length > 0;

                    this.updateRanking(data.data);
                    this.loading--;
                })
                .catch(error => {
                    console.error("Error al obtener datos de las ligas:", error);
                    this.loading--;
                });
        },

        updateRanking(data) {
            if (this.activeTabBAT === 3 && data.bronze && Array.isArray(data.bronze.data)) {
                this.rankingBAT = data.bronze.data;
            } else if (this.activeTabBAT === 2 && data.silver && Array.isArray(data.silver.data)) {
                this.rankingBAT = data.silver.data;
            } else if (this.activeTabBAT === 1 && data.gold && Array.isArray(data.gold.data)) {
                this.rankingBAT = data.gold.data;
            } else {
                this.rankingBAT = [];
            }
        },

        getMedalIcon(leagueName) {
            const leagueData = {
                'Oro': { name: 'Oro', iconMobile: '/../img-version2/icons/bateadores/position_gold.png', iconDesktop: '/../img-version2/icons/bateadores/position_gold_desktop.png' },
                'Plata': { name: 'Plata', iconMobile: '/../img-version2/icons/bateadores/position_silver.png', iconDesktop: '/../img-version2/icons/bateadores/position_silver_desktop.png' },
                'Bronce': { name: 'Bronce', iconMobile: '/../img-version2/icons/bateadores/position_bronze.png', iconDesktop: '/../img-version2/icons/bateadores/position_bronze_desktop.png' }
            };

            const isMobile = window.innerWidth <= 768;

            const league = leagueData[leagueName.charAt(0).toUpperCase() + leagueName.slice(1)];

            if (league) {
                return isMobile ? league.iconMobile : league.iconDesktop;
            }
            return '';
        },

        calculateRemainingDays(dateFinish) {
            const today = new Date();
            const endDate = new Date(dateFinish);
            const timeDifference = endDate - today;
            const daysRemaining = Math.ceil(timeDifference / (1000 * 3600 * 24));
            return daysRemaining;
        },

        updateFilteredRanking() {
            this.filteredRanking;
        },
        getClientPercentageForLeague(leagueName) {
            if (leagueName === 'Bronce') {
                return this.clientPercentage.bronze !== null && this.clientPercentage.bronze !== undefined && this.clientPercentage.bronze !== 0
                    ? this.clientPercentage.bronze + '%'
                    : '';
            } else if (leagueName === 'Plata') {
                return this.clientPercentage.silver !== null && this.clientPercentage.silver !== undefined && this.clientPercentage.silver !== 0
                    ? this.clientPercentage.silver + '%'
                    : '';
            } else if (leagueName === 'Oro') {
                return this.clientPercentage.gold !== null && this.clientPercentage.gold !== undefined && this.clientPercentage.gold !== 0
                    ? this.clientPercentage.gold + '%'
                    : '';
            }
            return '';
        },
        formatDate(dateString) {
            const months = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
            ];

            const date = new Date(dateString.replace(' ', 'T'));

            const day = String(date.getDate()).padStart(2, '0');
            const month = months[date.getMonth()];
            const year = date.getFullYear();

            return `${day} de ${month} de ${year}`;
        },

        validSegments(){
            const segmentsValid = [5, 11, 12, 15];
            if (segmentsValid.includes(this.clientSegmentationId)) {
                return true
            } else {
                return false
            }
        },
        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        }

    },
}
</script>
